<template>
  <div class="searchbox">
    <div class="searchbox__wrapper">
      <input
        type="text"
        placeholder="Search by Address / Block Number / TX ID"
        v-model="searchValue"
        @keyup.enter="search"
      />
      <button @click="search">
        <img src="../assets/img/magnifier.svg" />
      </button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      searchValue: "",
    };
  },

  methods: {
    search() {
      let str = this.searchValue;
      this.searchValue = "";

      let emptyRegex = /^\s*$/;
      let specialCharRegex = /^.*(?=.*[!@#$%^&+=~*]).*$/;

      if (!str || emptyRegex.test(str) || specialCharRegex.test(str)) {
        alert(" Please enter the correct value.");
        return;
      }

      const url = this.getURL(str);
      this.$router.push(url);
    },

    getURL(id) {
      // if (id.charAt(1) === "x") {
      //   return `/accounts/${id}`;
      // }

      id = id.trim();
      if (Number(id)) {
        return `/blocks/${id}`;
      } else if (id.length == 64) {
        return `/txs/${id}`;
      }
      return `/accounts/${id}`;
    },
  },
};
</script>

<style lang="scss">
@import "../scss/common";

@mixin borderStyle($direction) {
  border-top: 1px solid #0393f4;
  border-bottom: 1px solid #0393f4;
  border-#{$direction}: 1px solid #0393f4;
  border-top-#{$direction}-radius: 20px;
  border-bottom-#{$direction}-radius: 20px;
}

.searchbox {
  position: sticky;
  top: 0;
  min-height: 80px;
  display: flex;
  align-items: center;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 4, 0.09);
  background-color: #ffffff;

  &__wrapper {
    width: 100%;
    height: 41px;
    margin: 0 30px;
    display: flex;

    input {
      flex-grow: 1;
      box-sizing: border-box;
      max-width: 1053px;
      height: 100%;
      margin: 0;
      padding-left: 30px;
      outline: none;
      background-color: #ffffff;
      font-size: 14px;
      color: #333333;
      -webkit-appearance: none;
      -webkit-border-radius: 0;
      border-right: none;

      @include borderStyle(left);
      @include placeholder;
    }

    button {
      min-width: 57px;
      height: 100%;
      padding: 0;
      margin: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: #0393f4;
      cursor: pointer;
      border-left: none;

      @include borderStyle(right);

      // @include hoverTransition(#454545, #0393f4);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SearchBox.vue